<div class="relative" [class]="!isMaximized() ? treeContainerClass() : ''">
  <!-- increase the scroll area of the flow without changing the content height -->
  <div
    id="flow-steps-container"
    class="border border-neutral-200 bg-white rounded-lg p-2xl flex justify-center items-center min-w-full min-h-full overflow-hidden touch-none relative cursor-grab active:cursor-grabbing bg-[url('/assets/images/diagram/diagram-bg.png')] bg-cover bg-center bg-no-repeat before:content-[''] before:block before:w-[250rem] before:h-[250rem] before:absolute before:top-1/2 before:start-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:pointer-events-none"
    [style.height]="containerHeight()"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointerleave)="onPointerLeave($event)"
    (wheel)="onWheel($event)">
    <!-- Transform wrapper for panning -->
    <div
      id="pan-container"
      class="relative will-change-transform z-0 transition-transform duration-100 ease-out"
      [style.transform]="
        'translate(' + translateX() + 'px, ' + translateY() + 'px)'
      ">
      <!-- Scale wrapper for zooming -->
      <div
        id="zoom-container"
        class="will-change-transform origin-center transition-transform duration-200 ease-out"
        [style.transform]="'scale(' + zoom() + ')'">
        <!-- ── Horizontal layout ── -->
        <div
          id="step-container"
          class="select-none flex justify-center flex-row items-center relative min-w-max min-h-max w-fit">
          <div class="p-lg bg-primary-500 text-white rounded-lg text-sm">
            {{ 'steps_diagram_tab_start_label' | transloco }}
          </div>

          <div
            class="w-16 h-[.0938rem] bg-neutral-400 relative after:content-[''] after:absolute after:right-0 after:bottom-1/2 after:translate-y-1/2 after:w-0 after:h-0 after:border-t-[0.25rem] after:border-b-[0.25rem] after:border-l-[0.35rem] after:border-t-transparent after:border-b-transparent after:border-l-neutral-400 rtl:after:right-auto rtl:after:left-0 rtl:after:border-l-0 rtl:after:border-r-[0.35rem] rtl:after:border-r-neutral-400"></div>

          @for (
            item of positions();
            track $index;
            let isFirst = $first;
            let isLast = $last;
            let index = $index
          ) {
            @if (!isFirst) {
              <div
                class="w-8 h-[.0938rem] bg-neutral-400 relative after:content-[''] after:absolute after:right-0 after:bottom-1/2 after:translate-y-1/2 after:w-0 after:h-0 after:border-t-[0.25rem] after:border-b-[0.25rem] after:border-l-[0.35rem] after:border-t-transparent after:border-b-transparent after:border-l-neutral-400 rtl:after:right-auto rtl:after:left-0 rtl:after:border-l-0 rtl:after:border-r-[0.35rem] rtl:after:border-r-neutral-400"></div>
            }

            @if (item.steps.length === 1) {
              <!-- single step: normal card -->
              <lib-tree-step-card
                [step]="item.steps[0]"
                [positionName]="item.steps[0].name"
                [isFirstPosition]="!!isFirst"
                [stepIndex]="index"
                [positionsLength]="positions().length"
                [hasEmptyCircle]="false" />
            } @else {
              <lib-tree-step-card
                [step]="item.steps[0]"
                [positionName]="item.position_name"
                [isFirstPosition]="!!isFirst"
                [stepIndex]="index"
                [positionsLength]="positions().length"
                [hasEmptyCircle]="true" />

              <div
                class="w-8 h-[.0938rem] bg-neutral-400 relative after:content-[''] after:absolute after:right-0 after:bottom-1/2 after:translate-y-1/2 after:w-0 after:h-0 after:border-t-[0.25rem] after:border-b-[0.25rem] after:border-l-[0.35rem] after:border-t-transparent after:border-b-transparent after:border-l-neutral-400 rtl:after:right-auto rtl:after:left-0 rtl:after:border-l-0 rtl:after:border-r-[0.35rem] rtl:after:border-r-neutral-400"></div>

              <!-- parallel sub-steps bracket -->
              <!-- grid: 2rem left-connector | cards | 2rem right-connector, rows spaced by 6xl (3rem) -->
              <div class="grid grid-cols-[2rem_1fr_2rem] gap-y-6xl">
                @for (
                  step of item.steps;
                  track $index;
                  let isFirstStep = $first;
                  let isLastStep = $last
                ) {
                  <div
                    class="relative after:content-[''] after:absolute after:h-[.0938rem] after:top-1/2 after:-translate-y-1/2 after:left-0 after:right-0 after:bg-neutral-400 before:content-[''] before:absolute before:w-[.0938rem] before:left-0 before:bg-neutral-400 rtl:before:left-auto rtl:before:right-0"
                    [class]="
                      isFirstStep && isLastStep
                        ? 'before:top-1/2 before:bottom-1/2'
                        : isFirstStep
                          ? 'before:top-1/2 before:-bottom-6'
                          : isLastStep
                            ? 'before:-top-6 before:bottom-1/2'
                            : 'before:-top-6 before:-bottom-6'
                    ">
                    <!-- dot: left edge centred, RTL: right edge centred -->
                    <span
                      class="absolute w-2 h-2 rounded-full bg-neutral-400 top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 rtl:left-auto rtl:right-0 rtl:translate-x-1/2 rtl:-translate-y-1/2"></span>
                  </div>

                  <lib-tree-step-card
                    [step]="step"
                    [positionName]="''"
                    [isFirstPosition]="false"
                    [stepIndex]="index"
                    [positionsLength]="positions().length"
                    [applyMinHeight]="true"
                    [hasEmptyCircle]="true" />

                  <div
                    class="relative after:content-[''] after:absolute after:h-[.0938rem] after:top-1/2 after:-translate-y-1/2 after:left-0 after:right-0 after:bg-neutral-400 before:content-[''] before:absolute before:w-[.0938rem] before:right-0 before:bg-neutral-400 rtl:before:right-auto rtl:before:left-0"
                    [class]="
                      isFirstStep && isLastStep
                        ? 'before:top-1/2 before:bottom-1/2'
                        : isFirstStep
                          ? 'before:top-1/2 before:-bottom-6'
                          : isLastStep
                            ? 'before:-top-6 before:bottom-1/2'
                            : 'before:-top-6 before:-bottom-6'
                    ">
                    <!-- dot: right edge centred, RTL: left edge centred -->
                    <span
                      class="absolute w-2 h-2 rounded-full bg-neutral-400 top-1/2 right-0 translate-x-1/2 -translate-y-1/2 rtl:right-auto rtl:left-0 rtl:-translate-x-1/2 rtl:-translate-y-1/2"></span>
                  </div>
                }
              </div>
            }

            @if (!isLast && item.steps.length === 1) {
              <div class="w-8 h-[.0938rem] bg-neutral-400"></div>
            }
          }

          <div
            class="w-16 h-[.0938rem] bg-neutral-400 relative after:content-[''] after:absolute after:right-0 after:bottom-1/2 after:translate-y-1/2 after:w-0 after:h-0 after:border-t-[0.25rem] after:border-b-[0.25rem] after:border-l-[0.35rem] after:border-t-transparent after:border-b-transparent after:border-l-neutral-400 rtl:after:right-auto rtl:after:left-0 rtl:after:border-l-0 rtl:after:border-r-[0.35rem] rtl:after:border-r-neutral-400"></div>

          <div
            class="p-lg bg-primary-500 text-white rounded-lg inline-block text-sm">
            {{ 'steps_diagram_tab_end_label' | transloco }}
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (showTags()) {
    <lib-tree-tags [tags]="tags()" (tagsChanged)="onTagsChanged($event)" />
  }

  <!-- diagram actions -->
  @if (showActions()) {
    <lib-tree-actions
      [zoom]="zoom()"
      [isMaximized]="isMaximized()"
      [isPdfLoading]="pdfLoading()"
      (handleZoomOut)="zoomOut()"
      (handleZoomIn)="zoomIn()"
      (handleMaximize)="maximize()"
      (handleExportPDF)="exportPDF()" />
  }
</div>

@if (pdfLoading()) {
  <lib-overlay-loader />
}
